// extracted by mini-css-extract-plugin
export default {"label":"TextArea_label__ewxUT","textarea":"TextArea_textarea__dZ0pB"};